import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import './styles.scss';
import logo from '../../assets/images/logo/logoinno.png';
import { CONTACT } from '../../lib/contact';
import { getServiceContent, groupedServices, servicePath } from '../../content/services';
import { localeFromPath, servicesRoot, blogRoot } from '../../lib/i18n-routes';
import { getPost, postPath, PUBLISHED } from '../../content/blog';

function Footer() {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const locale = localeFromPath(pathname);

    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggle = () => setIsVisible(window.pageYOffset > 500);
        window.addEventListener('scroll', toggle);
        return () => window.removeEventListener('scroll', toggle);
    }, []);

    const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    const groups = groupedServices();
    const latestPosts = PUBLISHED
        .map((p) => ({ ...p, content: getPost(p.slug, locale) }))
        .filter((p) => p.content)
        .sort((a, b) => (a.date < b.date ? 1 : -1))
        .slice(0, 4);
    const home = locale === 'ru' ? '/ru' : '/';
    const year = new Date().getFullYear();

    return (
        <footer id="footer">
            <div className="footer-main">
                <div className="container">
                    <div className="footer-grid">
                        {/* Brend ustuni */}
                        <div className="footer-brand">
                            <Link to={home} className="footer-brand__logo">
                                <img src={logo} alt="Innobek" />
                            </Link>

                            <p className="footer-brand__text">{t('footer-desc')}</p>

                            <ul className="footer-contacts">
                                <li>
                                    <a href={CONTACT.phoneHref} className="footer-contacts__phone">
                                        {CONTACT.phoneDisplay}
                                    </a>
                                </li>
                                <li>
                                    <a href={CONTACT.telegram} target="_blank" rel="noreferrer">
                                        {CONTACT.telegramLabel}
                                    </a>
                                </li>
                                <li>{t('office-address')}</li>
                                <li>{t('work-hours-value')}</li>
                            </ul>
                        </div>

                        {/* Xizmatlar ustunlari */}
                        {groups.map((group) => (
                            <nav className="footer-col" key={group.key} aria-label={t(group.i18n)}>
                                <p className="footer-col__title">{t(group.i18n)}</p>
                                <ul>
                                    {group.items.map((s) => {
                                        const c = getServiceContent(s.slug, locale);
                                        if (!c) return null;
                                        return (
                                            <li key={s.slug}>
                                                <Link to={servicePath(s, locale)}>{c.hero.h1}</Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </nav>
                        ))}

                        {/* Kompaniya */}
                        <nav className="footer-col" aria-label={t('company')}>
                            <p className="footer-col__title">{t('company')}</p>
                            <ul>
                                <li><Link to={servicesRoot(locale)}>{t('all-services')}</Link></li>
                                <li><a href={`${home}#portfolio`}>{t('portfolio')}</a></li>
                                <li><a href={`${home}#haqimizda`}>{t('about-us')}</a></li>
                                <li><a href={`${home}#savollar`}>{t('questions')}</a></li>
                                <li><Link to={locale === 'ru' ? '/ru/contact' : '/contact'}>{t('connect')}</Link></li>
                            </ul>

                            <p className="footer-col__title footer-col__title--gap">{t('news')}</p>
                            <ul>
                                {latestPosts.map((p) => (
                                    <li key={p.slug}>
                                        <Link to={postPath(p, locale)}>{p.content.h1}</Link>
                                    </li>
                                ))}
                                <li><Link to={blogRoot(locale)}>{t('all-articles')}</Link></li>
                            </ul>
                        </nav>
                    </div>

                    <div className="footer-bottom">
                        <p>&copy; {year} Innobek. {t('rights')}</p>
                        <a href={CONTACT.telegram} target="_blank" rel="noreferrer" className="footer-bottom__tg">
                            <svg width="20" height="18" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                <path d="M28.8558 1.15613C28.3645 0.744 27.5929 0.685032 26.7951 1.0019H26.7938C25.9547 1.33498 3.04206 11.0576 2.10931 11.4548C1.93966 11.5131 0.458 12.0601 0.61062 13.2783C0.746864 14.3767 1.93769 14.8316 2.08311 14.884L7.9082 16.8572C8.29466 18.1299 9.71933 22.8253 10.0344 23.8284C10.2309 24.4537 10.5512 25.2754 11.1126 25.4445C11.6051 25.6325 12.0951 25.4607 12.4121 25.2145L15.9735 21.9466L21.7226 26.3822L21.8595 26.4632C22.2499 26.6343 22.6239 26.7198 22.9809 26.7198C23.2566 26.7198 23.5213 26.6686 23.7741 26.5662C24.6355 26.2163 24.98 25.4044 25.016 25.3123L29.3103 3.23038C29.5724 2.05102 29.2082 1.45097 28.8558 1.15613ZM13.0455 17.6465L11.0805 22.8305L9.11541 16.3505L24.1809 5.33444L13.0455 17.6465Z" fill="currentColor" />
                            </svg>
                            Telegram
                        </a>
                    </div>
                </div>
            </div>

            {isVisible && (
                <button type="button" onClick={scrollToTop} id="scroll-top" aria-label="Yuqoriga" />
            )}
        </footer>
    );
}

export default Footer;
